// extracted by mini-css-extract-plugin
export default {"swalContainer":"listaCliente_swalContainer__6Xo9n"};